import { cyrb53 } from "@/utils/cyrb53";

const DEFAULT_CSS = `font-family:"Menlo","Monaco","Consolas",monospace;`;

let _beforeTime = Date.now();
const log =
  process.env.NODE_ENV === "development"
    ? (
        enabled: boolean,
        title: string,
        type: "log" | "warn" | "error" | "groupCollapsed",
        args: unknown[]
      ) => {
        if (!enabled) return;
        const elapsed = Date.now() - _beforeTime;
        let formattedElapsed = (elapsed / 1000).toFixed(3).padStart(7, " ");
        if (formattedElapsed.length > 7) {
          formattedElapsed = "999.999";
        }
        _beforeTime = Date.now();
        let additionalMsg = "";
        if (typeof args[0] === "string") {
          args[0] = `#{${title}} ${args[0]}`;
        } else {
          args.unshift(`#{${title}}`);
        }
        if (typeof args[0] === "string") {
          const cssChunks: string[] = [""];
          additionalMsg =
            "%c " +
            (args.shift() as string).replace(/%c|#{([^}]+)}/g, (raw, key) => {
              if (raw === "%c") {
                cssChunks.push(DEFAULT_CSS + args.shift());
                return raw;
              }
              const h = cyrb53(key) % 360;
              cssChunks.push(
                DEFAULT_CSS +
                  "background-color:hsl(" +
                  h +
                  ",80%,80%);border-bottom:2px solid hsl(" +
                  h +
                  ",80%,50%);color:#000;font-weight:bold;font-size:10px;padding:0px 3px;border-radius:2px;",
                DEFAULT_CSS
              );
              return "%c" + key + "%c";
            });
          args.unshift(...cssChunks);
        }
        console[type](
          `%c${new Date(Date.now() + 9 * 60 * 60 * 1000).toISOString().slice(0, -1)}(${formattedElapsed})${additionalMsg}`,
          DEFAULT_CSS +
            `color:hsl(` +
            Math.max(0, 225 - elapsed * (225 / 1000)) +
            ",100%,70%);font-weight:bold;",
          ...args
        );
      }
    : () => {};
export const createLogger = (title: string, enabled = false) => ({
  enabled,
  log(...args: unknown[]) {
    log(this.enabled, title, "log", args);
  },
  warn(...args: unknown[]) {
    log(this.enabled, title, "warn", args);
  },
  error(...args: unknown[]) {
    log(this.enabled, title, "error", args);
  },
  groupCollapsed(...args: unknown[]) {
    log(this.enabled, title, "groupCollapsed", args);
  },
  stringifyError: (e: unknown) => {
    const baseMsg = e?.toString().trim() || "?";
    return (
      baseMsg + "\n" + (e as any)?.stack?.replace(baseMsg, "").trim() || ""
    );
  },
});
